<template>
  <v-container class="container text-center">
    <v-row class="m-0 p-0 m-l-10 m-r-10">
      <v-col cols="12" class="padding0">
        <span class="font-weight-bold">{{ dialTo }}</span>
      </v-col>
      <div class="div-btn-close">
        <v-btn
          fab
          small
          color="transparent"
          class="btn-close"
          @click="clearDialIsOpenPanel"
        >
          <v-icon small> fa-times </v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-row>
      <v-col cols="12"><calling-timer></calling-timer></v-col>
    </v-row>
    <!--<v-row v-if="dialIsShowNumPads" class="m-b-10">
      <v-col cols="12">
        <dial-number @dtmf="dtmf"></dial-number>
      </v-col>
    </v-row>-->
    <v-row v-if="dialIsShowNumPads" class="m-b-10">
      <v-col cols="12" class="padding0">
        <dial-pad @dtmf="dtmf"></dial-pad>
      </v-col>
    </v-row>
    <v-row class="m-b-10">
      <v-col cols="12" class="padding0">
        <calling-control :dialSession="dialSession"></calling-control>
      </v-col>
    </v-row>
    <v-row class="m-t-20">
      <v-col cols="12" class="padding0">
        <v-btn class="m-auto" color="primary" @click="hangup">
          <v-icon size="25" color="white"> mdi-phone-hangup </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DialPad from './components/dial_pad'
// import DialNumber from './components/dial_number'
import CallingTimer from './components/calling_timer'
import CallingControl from './components/calling_control'

export default {
  name: 'StateCalling',
  components: {
    DialPad,
    // DialNumber,
    CallingTimer,
    CallingControl
  },
  props: {
    dialSession: Object
  },
  computed: {
    ...mapGetters('call', [
      'dialTo',
      'dialDuration',
      'dialIsShowNumPads',
      'dialIsCalling',
      'dialDtmf'
    ])
  },
  methods: {
    ...mapActions('call', ['clearDialIsOpenPanel']),
    hangup() {
      this.$emit('hangup', null)
    },
    dtmf() {
      if (this.dialIsCalling) {
        const number = this.dialDtmf
        this.sendDtmf(number)
      }
    },
    sendDtmf(number) {
      const session = this.dialSession
      if (session && session.isEstablished()) {
        let pc = session.connection
        let senders = pc.getSenders()

        senders.forEach(sender => {
          if (sender.track && sender.track.kind === 'audio') {
            let dtmfSender = pc.createDTMFSender(sender.track)
            const lastDigit = number[number.length - 1]
            dtmfSender.insertDTMF(lastDigit, 100)
          }
        })
      } else {
        // console.error('DTMF sender not available.')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: white;
  position: absolute;
  z-index: 99;
  top: 4px;
  right: 5px;
  width: 250px;
  border-radius: 4px;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.div-btn-close {
  position: absolute;
  top: 0;
  right: 0;
}
.btn-close {
  width: 35px;
  height: 35px;
  box-shadow: none;
  border-radius: 50%;
}
</style>
